module.exports = __webpack_public_path__ + "media/images/flags/rw-6c7fb7c34ff6d533667473a2c273ff7c.svg";